import { render, staticRenderFns } from "./FormGeneralRecordStreamax.vue?vue&type=template&id=6553f506&scoped=true&"
import script from "./FormGeneralRecordStreamax.vue?vue&type=script&lang=ts&"
export * from "./FormGeneralRecordStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormGeneralRecordStreamax.vue?vue&type=style&index=0&id=6553f506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6553f506",
  null
  
)

export default component.exports